class LocalStorage {
  private get localStorage(): Storage | null {
    try {
      return window.localStorage;
    } catch (_) {
      return null;
    }
  }

  /**
   * Notify webcomponents, since the event will not be fired if the localStorage was changed
   * by the origin.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Window/storage_event}
   * @param key
   * @param value
   */
  public notify(key: string, newValue: string | null, oldValue: string | null) {
    window.dispatchEvent(
      new StorageEvent('storage', {
        key,
        newValue,
        oldValue,
      }),
    );
  }

  public get(key: string) {
    if (this.localStorage) {
      return this.localStorage.getItem(key);
    }

    return null;
  }

  public set(key: string, value: string) {
    if (this.localStorage) {
      const oldValue = this.get(key);
      this.localStorage.setItem(key, value);
      this.notify(key, value, oldValue);
    }
  }

  public remove(key: string) {
    if (this.localStorage) {
      const oldValue = this.get(key);
      this.localStorage.removeItem(key);
      this.notify(key, null, oldValue);
    }
  }
}

export const localStorage = new LocalStorage();
